import type { ContentPage } from "@/lib/content/types";

// CRM › Sales Enablement › Documents Library (leaf).
export const documentsLibrary: ContentPage = {
  slug: "sales-enablement/documents-library",
  template: "hrmsFeature",
  seo: {
    title: "Sales Document Library - Store & Share Content | GetBiz CRM",
    description: "Keep every proposal, deck and contract in one place with GetBiz CRM document library. Share, version and track sales content from the CRM.",
    keywords: ["sales document management", "document library", "sales content management", "crm documents"],
    ogImage: "/assets/data/seoimages/documents-library.webp",
  },
  leaf: {
    hero: {
      caption: "Documents Library",
      title: "Every Sales Document in One Place",
      description: "Store, share and track proposals, decks and contracts from a central library, right where your deals live.",
      h1: "caption",
    },
    split: {
      title: "Why Teams Choose Documents Library",
      bullets: [
        { title: "Central Repository", description: "One home for every sales document." },
        { title: "Version Control", description: "Always share the latest approved file." },
        { title: "Track Engagement", description: "See when prospects open what you send." },
        { title: "On the Record", description: "Attach documents to deals and accounts." },
      ],
      image: "/assets/images/img/product/crm/documents-library-lead-image.webp",
      imageAlt: "Documents Library — GetBiz CRM",
    },
    cardsHeading: {
      title: "Works With the Rest of Sales Enablement",
      description: "Documents Library connects to every other part of Sales Enablement in GetBiz CRM.",
    },
    cards: [
      { title: "Finance", href: "/crm-software/sales-enablement/finance/", description: "Manage quotes, invoices and payments alongside deals so revenue moves from closed-won to collected without gaps.", image: "/assets/images/img/product/crm/finance.webp", imageAlt: "GetBiz CRM finance" },
      { title: "Configure, Price, Quote (CPQ)", href: "/crm-software/sales-enablement/configure-price-quote/", description: "Configure products, apply the right pricing and generate professional quotes instantly.", image: "/assets/images/img/product/crm/configure-price-quote.webp", imageAlt: "GetBiz CRM configure, price, quote (cpq)" },
      { title: "Calendar", href: "/crm-software/sales-enablement/calendar/", description: "Sync calendars, share booking links and see all your meetings next to the deals and contacts they belong to.", image: "/assets/images/img/product/crm/calendar.webp", imageAlt: "GetBiz CRM calendar" },
      { title: "SalesInbox", href: "/crm-software/sales-enablement/salesinbox/", description: "Work email inside the CRM with full deal context beside every message.", image: "/assets/images/img/product/crm/salesInbox.webp", imageAlt: "GetBiz CRM salesinbox" },
    ],
    testimonials: {
      title: "Businesses across India love & trust GetBiz!",
      description: "See why teams choose GetBiz CRM to run their sales.",
    },
    bookDemoTitle: "See Documents Library in action.",
    relatedBlogs: "static",
    metaKey: "sales-enablement-documents-library",
  },
  sections: [],
};
